angular.module('unergie.main')
.filter('fta', (ContractConstants) => {
    const ftaMapping = {}
    _.each(ContractConstants.ref.ftas, (fta) => (ftaMapping[fta.value] = fta.label))

    return (val) => {
        return ftaMapping[val] || val
    }
})
